const doOrderAlphabetically = array => {
    let result = array.sort().reduce((accumulator, name) => {
        // get first letter of current name
        let alphabet = name[0];

        // if previously there is no record of current alphabet then create it
        if (!accumulator[alphabet]) {
            accumulator[alphabet] = {
                alphabet: alphabet,
                records: [name]
            };
        } else {
            /**
             * and if previously any record exist in accumulator of current alphabet
             * then push the record into that alphabet's array
             */
            accumulator[alphabet].records.push(name);
        }

        return accumulator;
    }, {});

    // Convert the result into an array and return
    return Object.values(result);
}

export {
    doOrderAlphabetically
}
